import { ReduxModule } from 'react-website';

const redux = new ReduxModule('GLOBAL');

// This is the Redux reducer which now
// handles the asynchronous actions defined above.
export default redux.reducer({ mobile: false });
